import { M_InputTextField } from "../../../../M_Components";
import { useTranslation } from "react-i18next";
import '../../../genericEntity/entity/entity.css'
import '../../../../App.css'

export const CurrencyForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();

    const handleChange = (property, value) => {
        propertyChangeCallback(property, value);
    }

    const handleNumberValueChange = (property, value) => {
        const regex = /^-?\d*\.?\d*$/;
        if (regex.test(value)) {
            if (value === "") {
                propertyChangeCallback(property, null);
                return;
            }
            propertyChangeCallback(property, value);
        }
    }

    return (
        <>
            <div className="field-one-columns" >
                <M_InputTextField
                    label={t("NgeDefaultValue")}
                    value={field.defaultValue ?? ""}
                    onChange={(e) => handleNumberValueChange("defaultValue", e.target.value)}
                    disabled={!canEdit}
                    type="number"
                />
            </div>
            <div className="field-one-columns" >
                <M_InputTextField
                    label={t("NgeUnit")}
                    value={field.unit ?? ""}
                    onChange={(e) => handleChange("unit", e.target.value)}
                    disabled={!canEdit}
                />
            </div>
        </>
    )
}
